import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
  errorInfo?: ErrorInfo
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)
    this.setState({ errorInfo })
  }

  render() {
    if (this.state.hasError) {
      const { error, errorInfo } = this.state
      return (
        <div style={{
          padding: '2rem', maxWidth: 900, margin: '4rem auto',
          fontFamily: 'system-ui, sans-serif', color: '#fff',
          background: '#1a1a1a', borderRadius: 12, border: '1px solid #ef4444',
        }}>
          <h1 style={{ color: '#ef4444', marginTop: 0 }}>⚠️ Render error</h1>
          <p style={{ color: '#ccc' }}>
            React-компонент упал при рендере. Скорее всего стейл-кэш JS в браузере
            или несовместимые props — попробуй <b>Cmd+Shift+R</b> (Mac) /
            <b> Ctrl+Shift+R</b> (Win) для жёсткого обновления.
          </p>
          <h3 style={{ color: '#fbbf24' }}>Error:</h3>
          <pre style={{
            background: '#0a0a0a', padding: '1rem', borderRadius: 8,
            color: '#fbbf24', overflowX: 'auto', fontSize: 12,
          }}>
            {error?.name}: {error?.message}
          </pre>
          {error?.stack && (
            <>
              <h3 style={{ color: '#94a3b8' }}>Stack:</h3>
              <pre style={{
                background: '#0a0a0a', padding: '1rem', borderRadius: 8,
                color: '#94a3b8', overflowX: 'auto', fontSize: 11,
                maxHeight: 300,
              }}>
                {error.stack}
              </pre>
            </>
          )}
          {errorInfo?.componentStack && (
            <>
              <h3 style={{ color: '#94a3b8' }}>Component stack:</h3>
              <pre style={{
                background: '#0a0a0a', padding: '1rem', borderRadius: 8,
                color: '#94a3b8', overflowX: 'auto', fontSize: 11,
                maxHeight: 300,
              }}>
                {errorInfo.componentStack}
              </pre>
            </>
          )}
          <div style={{ marginTop: '1.5rem', display: 'flex', gap: 8 }}>
            <button
              onClick={() => { this.setState({ hasError: false, error: undefined, errorInfo: undefined }) }}
              style={{
                background: '#22c55e', color: '#000', padding: '8px 16px',
                border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600,
              }}
            >
              Попробовать снова
            </button>
            <button
              onClick={() => { window.location.href = '/' }}
              style={{
                background: '#3b82f6', color: '#fff', padding: '8px 16px',
                border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600,
              }}
            >
              На главную
            </button>
            <button
              onClick={() => { window.location.reload() }}
              style={{
                background: '#ef4444', color: '#fff', padding: '8px 16px',
                border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600,
              }}
            >
              Перезагрузить страницу
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
